import classNames from "classnames";
import styles from "@/components/summaryCard/summaryStatTiles.module.css";

export interface SummaryStat {
  label: string;
  value: number;
  isFailureCount?: boolean;
}

interface Props {
  stats: SummaryStat[];
}

export default function SummaryStatTiles({ stats }: Props) {
  return (
    <div className={styles.statTiles}>
      {stats.map(({ label, value, isFailureCount }) => (
        <div
          key={label}
          className={classNames(styles.statTile, {
            [styles.statTileFailed]: isFailureCount && value > 0,
          })}
        >
          <span className={styles.statValue}>{value}</span>
          <span className={styles.statLabel}>{label}</span>
        </div>
      ))}
    </div>
  );
}
